import * as L from 'leaflet';
import { useCallback, useEffect, useRef, useState } from "react";
import { defaultMapConfig, useMapConfig } from '../../../../components/SubjectsMap/helper';

export default function CoordinatesViewer({ coordinates = {} }) {
  const [mapRef, setMapRef] = useState();
  const container = useRef();
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();

  // Creates map instance
  const createInstance = useCallback(() => {
    if (container.current) {
      var c = L.DomUtil.get(document.getElementById(container.current));
      if (c != null) {
        c._leaflet_id = null;
      }
      const map = L.map(container.current, {
        ...defaultMapConfig,
        center: [0, 0],
        zoom: 2,
        zoomControl: true,
        zoomSnap: 0,
      });
      L.control.scale().addTo(map);
      L.tileLayer(TILE_LAYER_URL, { access_token: MAP_TOKEN }).addTo(map);
      return map;
    }
  }, [TILE_LAYER_URL, MAP_TOKEN]);

  // Create map instance when component is mounted
  useEffect(() => {
    if (!mapRef) {
      const map = createInstance();
      const p = L.polygon(coordinates.coordinates, { color: '#00809E' }).addTo(map);
      map.fitBounds(p.getBounds(), { padding: [20, 20] });
      setMapRef(map);
    }
  }, []);

  return <div style={{ width: 500, height: 500 }} ref={container} />;
}
